export const config = {
  mediaBaseurl:
    "https://firebasestorage.googleapis.com/v0/b/bildstudio-e98d8.appspot.com/o/project_photos%2f",
  mediaQueryString: "?alt=media"
};
